import { AppRouteProps } from "@bsm/component";
import React from "react";

const TeacherDetailsParamsContainer = React.lazy(() => import('./containers/TeacherDetailsParamsContainer'));

export const TeacherDetailsParamsRoutes: Array<AppRouteProps> = [
    {
        path: "params",
        title: '{{TeacherNameDetailsTab}}',
        roles: ["TEACHER_EDITING"],
        element: <TeacherDetailsParamsContainer />
    }
]